import { Selector } from '@ngxs/store';
import { BillModel } from '@data-layer/models/payments';
import { UserBillingStateModel } from './billing-state.model';
import { UserBillingState } from './billing.state';

export class UserBillingSelectors {
  @Selector([UserBillingState])
  public static isLoading(state: UserBillingStateModel): boolean {
    return state?.isLoading;
  }

  @Selector([UserBillingState])
  public static getPageLimit(state: UserBillingStateModel): number {
    return state?.limit;
  }

  @Selector([UserBillingState])
  public static getPageOffset(state: UserBillingStateModel): number {
    return state?.offset;
  }

  @Selector([UserBillingState])
  public static getTotal(state: UserBillingStateModel): number {
    return state?.total;
  }

  @Selector([UserBillingState])
  public static getBillList(state: UserBillingStateModel): BillModel[] {
    return state?.billList;
  }
}
